<ng-container *ngLet="{ xScale: getXScale() } as values">
  <div *ngIf="!isEmpty(); else zeroState" class="visualization">
    <div class="tick-container" [style.grid-row]="getTickContainerGridRow()">
      <div
        *ngFor="let tick of getXTicks()"
        class="tick"
        [style.left.%]="values.xScale(tick)"
      ></div>
    </div>
    <div class="tick-label-container">
      <span
        *ngFor="let tick of getXTicks()"
        class="tick-label"
        [style.left.%]="values.xScale(tick)"
      >
        {{ valueFormatter(tick) }}
      </span>
    </div>
    <ng-container *ngFor="let point of getDataPoints(); let i = index">
      <div [style.grid-row]="i + 2" class="label" truncate>
        {{ point.label }}
      </div>
      <div
        [style.grid-row]="i + 2"
        class="bar-container"
        *ngIf="values.xScale !== null"
      >
        <span class="bar" [style.width.%]="values.xScale(point.value)"></span>
      </div>
      <div [style.grid-row]="i + 2" class="value">
        {{ valueFormatter(point.value) }}
        <ng-container *ngIf="point.detail !== null">
          ({{ point.detail }})
        </ng-container>
      </div>
    </ng-container>
  </div>
</ng-container>

<ng-template #zeroState>
  <div class="zero-state">No data to display.</div>
</ng-template>
